/* eslint-disable */
import * as util from "@/api/member";
import { endMemberImpersonation } from "@/api/login";

const state = {
    numActiveVoucherTotal: 0,
    numLicenseTotal: 0,
    numAgentTotal: 0,
    numMessageTotal: 0,
    numMessageSuccessTotal: 0,
    numMessageErrorTotal: 0,
    numMessagePendingTotal: 0,
    numContactsTotal: 0,
};


const mutations = {
    SET_numContactsTotal: (state, value) => {
        state.numContactsTotal = value
    },
    SET_numActiveVoucherTotal: (state, value) => {
        state.numActiveVoucherTotal = value
    },
    SET_numLicenseTotal: (state, value) => {
        state.numLicenseTotal = value
    },
    SET_numAgentTotal: (state, value) => {
        state.numAgentTotal = value
    },
    SET_numMessageTotal: (state, value) => {
        state.numMessageTotal = value
    },
    SET_numMessageSuccessTotal: (state, value) => {
        state.numMessageSuccessTotal = value
    },
    SET_numMessageErrorTotal: (state, value) => {
        state.numMessageErrorTotal = value
    },
    SET_numMessagePendingTotal: (state, value) => {
        state.numMessagePendingTotal = value
    },
};

const actions = {
    updateDeleteChatStatus({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.updateDeleteChatStatus(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    settingAutoSwitchSender({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.settingAutoSwitchSender(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getContactsTotal({ commit }) {
        return new Promise((resolve, reject) => {
            util.getContactsTotal().then(response => {
                const { data } = response;
                commit("SET_numContactsTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateBank({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateBank(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getTimezones() {
        return new Promise((resolve, reject) => {
            util.getTimezones().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updatePassword({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updatePassword(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateTimezone({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateTimezone(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateProfile({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateProfile(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    monthlyAgentsStatistic({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.monthlyAgentsStatistic(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    summaryAgents({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.summaryAgents(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    monthlyActiveLicenses({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.monthlyActiveLicenses(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getActiveVoucherTotal({ commit }) {
        return new Promise((resolve, reject) => {
            util.getActiveVoucherTotal().then(response => {
                const { data } = response;
                commit("SET_numActiveVoucherTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getLicenseTotal({ commit }) {
        return new Promise((resolve, reject) => {
            util.getLicenseTotal().then(response => {
                const { data } = response;
                commit("SET_numLicenseTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getAgentTotal({ commit }) {
        return new Promise((resolve, reject) => {
            util.getAgentTotal().then(response => {
                const { data } = response;
                commit("SET_numAgentTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMessageTotal({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getMessageTotal(dataParams).then(response => {
                const { data } = response;
                commit("SET_numMessageTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMessageSuccess({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getMessageSuccess(dataParams).then(response => {
                const { data } = response;
                commit("SET_numMessageSuccessTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMessagePending({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getMessagePending(dataParams).then(response => {
                const { data } = response;
                commit("SET_numMessagePendingTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMessageError({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getMessageError(dataParams).then(response => {
                const { data } = response;
                commit("SET_numMessageErrorTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    endImpersonation() {
        return new Promise((resolve, reject) => {
            endMemberImpersonation().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/member.js